import React, { useEffect, useState } from 'react';
import styles from 'components/nonPodiatry/page.module.scss';
import Button from 'components/common/button';
import { StateType } from 'reducer';
import { NonPodiatryOptionsType } from 'types/types';
import { usePersistNonPodiatryReducer } from 'reducer/nonPodiatry';
import clsx from 'clsx';
import MetaTag from 'components/meta';

type Props = {
  nextPage: number;
  currentPage?: number;
  actionPage: string;
  options: NonPodiatryOptionsType;
  multiple?: boolean;
  nextOrSubmitButton: (nextPage: number, submit?: boolean) => void;
};

function HaveYouSeenOtherProviders({
  nextPage,
  nextOrSubmitButton,
  options,
  multiple = true,
  actionPage,
}: Props) {
  const [title, setTitle] = useState('');
  const [questionList, setQuestionList] = useState<string[]>([]);
  const [error, setError] = useState(false);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [state, dispatch] = usePersistNonPodiatryReducer();

  useEffect(() => {
    setQuestionList(options.options);
    setTitle(options.title);
    if (state) {
      const data = state.find((object: StateType) => object.name === actionPage);
      if (data) setSelectedItems(data.value);
    }
  }, [state, options]);

  const onSelectOptions = (item: string) => {
    if (multiple) {
      setSelectedItems((old) => {
        if (old.find((value) => value === item)) {
          return old.filter((data) => data !== item);
        } return [...old, item];
      });
    } else {
      setSelectedItems([item]);
    }
    setError(false);
  };

  const clickNextOrSubmit = async () => {
    if (selectedItems.length === 0) {
      setError(true);
      return;
    }
    await dispatch({
      type: actionPage,
      name: title,
      value: selectedItems,
    });
    const isSubmit = selectedItems.toString() === 'No';
    nextOrSubmitButton(nextPage, isSubmit);
  };

  return (
    <>
      <MetaTag title={title} />
      <h2 className={`marginTopZero ${styles.titleText}`}>{title}</h2>
      {error && (
      <p className="error-message">Please select an image.</p>
      )}
      <div>
        {questionList.map((item, index) => {
          const isSelected = selectedItems.includes(item);
          return (
            <p
              key={item}
              className={clsx('option', { 'selected-option': isSelected })}
              onClick={() => onSelectOptions(item)}
              onKeyUp={() => {}}
            >
              {item}
            </p>
          );
        })}
      </div>
      <div className="next-button-fixed">
        <Button onClick={clickNextOrSubmit}>
          {selectedItems.toString() === 'Yes' ? 'Next' : 'Submit'}
        </Button>
      </div>
    </>
  );
}

export default HaveYouSeenOtherProviders;
